import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum approvalStatusEnum {
  NOTINITIATED = 'NOTINITIATED',
  APPROVED = 'APPROVED',
  UNAPPROVED = 'UNAPPROVED',
  REJECTED = 'REJECTED',
  ONHOLD = 'ONHOLD',
  DEACTIVATED = 'DEACTIVATED',
  REGISTERED = 'REGISTERED',
  INPROCESS = 'INPROCESS',
}

enum kycEnum {
  NI = 'NI',
  UR = 'UR',
  RJ = 'RJ',
  VD = 'VD',
}

enum rolesEnum {
  ROLE_SUPER = 'ROLE_SUPER',
  ADMIN = 'ADMIN',
  USER = 'USER',
  INTERVIEWER = 'INTERVIEWER',
}

export interface UserState {
  approval_status: approvalStatusEnum;
  avatar_image_url: string | null;
  company: {
    id: number | null;
    name: string;
  };
  device_id: string | null;
  email: string;
  ext_user_token: string | null;
  first_name: string;
  kyc_verified: kycEnum;
  last_name: string;
  phone_no: string;
  profile_name: string;
  roles: [{ id: number | null; name: rolesEnum }];
  token: string | null;
  mic: boolean;
  video: boolean;
  blur: boolean;
  isBlurSupported: boolean;
  speakerDeviceId: string | null;
  micDeviceId: string | null;
  cameraDeviceId: string | null;
}

const initialState: UserState = {
  approval_status: approvalStatusEnum.NOTINITIATED,
  avatar_image_url: null,
  company: {
    id: null,
    name: '',
  },
  device_id: null,
  email: '',
  ext_user_token: null,
  first_name: '',
  kyc_verified: kycEnum.NI,
  last_name: '',
  phone_no: '',
  profile_name: '',
  roles: [{ id: null, name: rolesEnum.USER }],
  token: null,
  mic: true,
  video: true,
  blur: false,
  isBlurSupported: false,
  speakerDeviceId: null,
  micDeviceId: null,
  cameraDeviceId: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<UserState>) => {
      const {
        approval_status,
        avatar_image_url,
        company,
        device_id,
        email,
        ext_user_token,
        first_name,
        kyc_verified,
        last_name,
        phone_no,
        profile_name,
        roles,
        token,
      } = action.payload;
      state.approval_status = approval_status;
      state.avatar_image_url = avatar_image_url;
      state.company = company;
      state.device_id = device_id;
      state.email = email;
      state.ext_user_token = ext_user_token;
      state.first_name = first_name;
      state.kyc_verified = kyc_verified;
      state.last_name = last_name;
      state.phone_no = phone_no;
      state.profile_name = profile_name;
      state.roles = roles;
      state.token = token;
    },
    toggleMic: (state) => {
      state.mic = !state.mic;
    },
    toggleVideo: (state) => {
      state.video = !state.video;
    },
    toggleBlur: (state) => {
      state.blur = !state.blur;
    },
    setSpeakerDeviceId: (state, action: PayloadAction<string>) => {
      state.speakerDeviceId = action.payload;
    },
    setMicDeviceId: (state, action: PayloadAction<string>) => {
      state.micDeviceId = action.payload;
    },
    setCameraDeviceId: (state, action: PayloadAction<string>) => {
      state.cameraDeviceId = action.payload;
    },
  },
});

export const {
  setUserInfo,
  toggleMic,
  toggleVideo,
  toggleBlur,
  setSpeakerDeviceId,
  setMicDeviceId,
  setCameraDeviceId,
} = userSlice.actions;

export default userSlice.reducer;
